import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react'
import { config } from './config'

export type AuthUser = { email: string | null; name: string | null; role: 'admin' | 'user' }

const AuthContext = createContext<{ user: AuthUser | null; loading: boolean; refresh: () => Promise<void> }>({
  user: null, loading: true, refresh: async () => {},
})

export const useAuth = () => useContext(AuthContext)

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<AuthUser | null>(null)
  const [loading, setLoading] = useState(true)
  const refresh = useCallback(async () => {
    setLoading(true)
    try {
      const r = await fetch(`${config.apiUrl}/api/auth/me`, { credentials: 'include' })
      setUser(r.ok ? await r.json() : null)
    } catch {
      setUser(null)
    } finally {
      setLoading(false)
    }
  }, [])
  useEffect(() => { void refresh() }, [refresh])
  return <AuthContext.Provider value={{ user, loading, refresh }}>{children}</AuthContext.Provider>
}

export function Loading() {
  return <div className="flex min-h-dvh items-center justify-center text-sm text-[#999]">Loading…</div>
}

export async function logout() {
  await fetch(`${config.apiUrl}/api/auth/logout`, { method: 'POST', credentials: 'include' })
}
